import { filter, map, clone } from 'ramda';

// TODO: Move to fields.js helper
export function processFields(fields, onFormatValue) {
  const dataForPost = {};
  if(fields && Object.keys(fields).length > 0) {
    for (let field in fields) {
      if (!fields[field].system && !fields[field].value && !(fields[field] instanceof Array)) {
        continue;
      }
      if (fields[field] instanceof Array) {
        for (let i = 0; i < fields[field].length; i++) {
          let currentField = fields[field][i][fields[field][i].name];
          if (currentField && currentField.system && currentField.system.relatedTo && currentField.system.name) {
            if (!dataForPost.hasOwnProperty(currentField.system.relatedTo)) {
              dataForPost[currentField.system.relatedTo] = [];
            }
            let tempObj = {};
            tempObj[currentField.system.name] = onFormatValue ? onFormatValue(currentField) : currentField.value;
            if (currentField.id) {
              tempObj.id = currentField.id;
            }
            dataForPost[currentField.system.relatedTo].push(tempObj);
          } else {
            let currentFieldSet = fields[field][i];

            let pushTo = null;
            let tempObj = {};
            for (let cField in currentFieldSet) {
              let currentFildInSet = currentFieldSet[cField];
              if (currentFildInSet && currentFildInSet.system) {
                if (pushTo === null) {
                  pushTo = currentFildInSet.system.relatedTo;
                }

                tempObj[currentFildInSet.system.name] = onFormatValue ? onFormatValue(currentFildInSet) : currentFildInSet.value;
              }
            }

            if (!dataForPost.hasOwnProperty(pushTo)) {
              dataForPost[pushTo] = [];
            }

            dataForPost[pushTo].push(tempObj);
          }
        }
      } else {        
        dataForPost[fields[field].system.name] = onFormatValue ? onFormatValue(fields[field]) : fields[field].value;
      }
    }
  }
  return dataForPost;
}



// WEBPACK FOOTER //
// ./src/utils/prePost.js